export default "__VITE_ASSET__Cr40gHy8__"